import { PanelLeftClose, PanelLeftOpen } from "lucide-react";
import React from "react";

interface Props {
  isCollapsed: boolean;
  toggleCollapse: () => void;
}

const SidebarCollapseButton: React.FC<Props> = ({
  isCollapsed,
  toggleCollapse,
}) => {
  return (
    <button
      className="absolute bottom-[38px] -right-3 h-6 w-6 flex items-center justify-center rounded-md border border-gray-200 bg-white hover:bg-gray-100 transition-colors shadow-sm z-10"
      onClick={toggleCollapse}
      title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
    >
      {isCollapsed ? (
        <PanelLeftOpen className="h-3.5 w-3.5 text-gray-500" />
      ) : (
        <PanelLeftClose className="h-3.5 w-3.5 text-gray-500" />
      )}
    </button>
  );
};

export default SidebarCollapseButton;